export const siteConfig = {
  breakpoint: {
    // xxs: 576,
    xs: 768,
    sm: 1025,
    // md: 1280,
    // lg: 1440,
    // xl: 1600,

    shiftPoint: 1025,
  },

  delay: {
    resize: 200,
    scroll: 100,
  },

  id: {
    header: 'js-header',
    footer: 'js-footer',
    splash: 'js-splash',
  },

  class: {
    act: 'is-act',
    inact: 'is-inact',
    view: 'is-view',
    open: 'is-open',
    fixed: 'is-fixed',
  },
} as const;
